module.exports = __webpack_public_path__ + "static/img/prod_01.a58463a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/relay-event/prod_01.png
// module id = 2tYC
// module chunks = 0